export const pillsNavDefaults = {
  items: [
    {
      label: 'All',
      href: '/',
      isVisible: true,
    },
    {
      label: 'Category 1',
      href: '/',
      isVisible: true,
    },
    {
      label: 'Category 2',
      href: '/',
      isVisible: true,
    },
  ],
}
